/**
 * Date utility functions for consistent date formatting across the application
 */

/**
 * Format a date to dd-mm-yyyy format
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in dd-mm-yyyy format
 */
export const formatDateDDMMYYYY = (date) => {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

/**
 * Format a date to dd-mm-yyyy hh:mm format
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in dd-mm-yyyy hh:mm format
 */
export const formatDateTimeDDMMYYYY = (date) => {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};
